(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("foundation"));
	else if(typeof define === 'function' && define.amd)
		define(["foundation"], factory);
	else if(typeof exports === 'object')
		exports["Foundation"] = factory(require("foundation"));
	else
		root["Foundation"] = factory(root["foundation"]);
})(this, (__WEBPACK_EXTERNAL_MODULE_foundation__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./sources/DLDB+Bookings.ts":
/*!**********************************!*\
  !*** ./sources/DLDB+Bookings.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Booking: () => (/* binding */ Booking),
/* harmony export */   isValidEmail: () => (/* binding */ isValidEmail),
/* harmony export */   isValidPhone: () => (/* binding */ isValidPhone),
/* harmony export */   isValidPostalCode: () => (/* binding */ isValidPostalCode)
/* harmony export */ });
/* harmony import */ var _DLDB__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DLDB */ "./sources/DLDB.ts");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_1__);


function isValidEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}
function isValidPhone(phone) {
    // EU numbers | USA numbers
    var re = /^((\+([0-9]{1,3})[-. ])?([0-9]{8,9}))|(\(\d{3}\)[ ](\d{3})-(\d{4}))$/;
    return re.test(phone);
}
function isValidPostalCode(zipcode) {
    var re = /^[0-9]{5}$/;
    return re.test(zipcode);
}
_DLDB__WEBPACK_IMPORTED_MODULE_0__.DLDB.prototype.booking = function () {
    if (this._booking != null)
        return this._booking;
    // Create and cache the cart
    this._booking = new Booking();
    return this._booking;
};
var Booking = /** @class */ (function () {
    function Booking() {
        this.id = foundation__WEBPACK_IMPORTED_MODULE_1__.UUID.UUID();
        this.pax = 0;
        this.countryISO2 = null;
        this.hallComments = null;
        this.comments = null;
    }
    return Booking;
}());



/***/ }),

/***/ "./sources/DLDB+Cart.ts":
/*!******************************!*\
  !*** ./sources/DLDB+Cart.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Cart: () => (/* binding */ Cart),
/* harmony export */   CartLine: () => (/* binding */ CartLine)
/* harmony export */ });
/* harmony import */ var _DLDB__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DLDB */ "./sources/DLDB.ts");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_1__);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


_DLDB__WEBPACK_IMPORTED_MODULE_0__.DLDB.prototype.cart = function () {
    if (this._cart != null)
        return this._cart;
    // Create and cache the cart
    this._cart = new Cart();
    return this._cart;
};
var CartLine = /** @class */ (function () {
    function CartLine(productID, productName, price, quantity, hasRecommendProducts) {
        if (quantity === void 0) { quantity = 0; }
        if (hasRecommendProducts === void 0) { hasRecommendProducts = false; }
        this.productID = productID;
        this.productName = productName;
        this.productPrice = price;
        this.quantity = quantity;
        this.hasRecommendProducts = hasRecommendProducts;
    }
    return CartLine;
}());

var Cart = /** @class */ (function (_super) {
    __extends(Cart, _super);
    function Cart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._lines = [];
        _this._lines_by_product_id = {};
        _this._subTotal = 0;
        _this._discount = 0;
        _this._total = 0;
        _this._recommend_products_by_product_id = {};
        _this._recommend_products_by_id = {};
        _this._date = null;
        _this._time_id = null;
        _this._name = null;
        _this._phone = null;
        _this._email = null;
        _this._comments = null;
        return _this;
    }
    Object.defineProperty(Cart.prototype, "lines", {
        get: function () { return this._lines; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "subTotal", {
        get: function () { return this._subTotal; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "discount", {
        get: function () { return this._discount; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "total", {
        get: function () { return this._total; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "recommendProducts", {
        get: function () {
            return Object.values(this._recommend_products_by_id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "totalQuantity", {
        get: function () {
            return this._lines.reduce(function (acc, line) { return acc + line.quantity; }, 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "date", {
        get: function () { return this._date; },
        set: function (date) {
            this._date = date;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "time", {
        get: function () { return this._time_id; },
        set: function (time_id) {
            this._time_id = time_id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "name", {
        get: function () { return this._name; },
        set: function (name) {
            this._name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "phone", {
        get: function () { return this._phone; },
        set: function (phone) {
            this._phone = phone;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "email", {
        get: function () { return this._email; },
        set: function (email) {
            this._email = email;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Cart.prototype, "comments", {
        get: function () { return this._comments; },
        set: function (comments) {
            this._comments = comments;
        },
        enumerable: false,
        configurable: true
    });
    Cart.prototype.increaseProductQuantity = function (productID, name, price, quantity, recommendProducts) {
        if (quantity === void 0) { quantity = 1; }
        var line = this._lines_by_product_id[productID];
        var q = line ? line.quantity + quantity : quantity;
        this.updateProductQuantity(productID, name, price, q, recommendProducts);
    };
    Cart.prototype.decreaseProductQuantity = function (productID, name, price, quantity, recommendProducts) {
        if (quantity === void 0) { quantity = 1; }
        var line = this._lines_by_product_id[productID];
        var q = line ? line.quantity - quantity : quantity;
        this.updateProductQuantity(productID, name, price, q, recommendProducts);
    };
    Cart.prototype.updateProductQuantity = function (productID, name, price, quantity, recommendProducts) {
        this.willChangeValueForKey("lines");
        var line = this._lines_by_product_id[productID];
        if (line != null) {
            this._subTotal -= price * line.quantity;
            this._total -= price * line.quantity;
            if (quantity <= 0) {
                delete this._lines_by_product_id[productID];
                this._lines = this._lines.filter(function (l) { return l.productID !== productID; });
                delete this._recommend_products_by_product_id[productID];
            }
            else {
                line.quantity = quantity;
                this._subTotal += price * quantity;
                this._total += price * quantity;
            }
        }
        else {
            line = new CartLine(productID, name, price, quantity, recommendProducts.length > 0);
            this._lines_by_product_id[productID] = line;
            this._lines.push(line);
            this._subTotal += price * quantity;
            this._total += price * quantity;
            var recommend_lines = [];
            for (var _i = 0, recommendProducts_1 = recommendProducts; _i < recommendProducts_1.length; _i++) {
                var rp = recommendProducts_1[_i];
                var l = new CartLine(rp["ID"], rp["Name"], rp["Price"], 0, false);
                recommend_lines.push(l);
                this._recommend_products_by_id[rp["ID"]] = l;
            }
            if (recommend_lines.length > 0)
                this._recommend_products_by_product_id[productID] = recommend_lines;
        }
        this.didChangeValueForKey("lines");
    };
    Cart.prototype.showExtrasController = function () {
        return Object.keys(this._recommend_products_by_product_id).length > 0;
    };
    Cart.prototype.quantityByProductID = function (productID) {
        var line = this._lines_by_product_id[productID];
        return line ? line.quantity : 0;
    };
    return Cart;
}(foundation__WEBPACK_IMPORTED_MODULE_1__.NSObject));



/***/ }),

/***/ "./sources/DLDB+Formatters.ts":
/*!************************************!*\
  !*** ./sources/DLDB+Formatters.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _DLDB__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./DLDB */ "./sources/DLDB.ts");


// Add the currencyFormatter method to DLDB prototype
_DLDB__WEBPACK_IMPORTED_MODULE_1__.DLDB.prototype.currencyFormatter = function () {
    if (this._currencyFormatter != null)
        return this._currencyFormatter;
    // Create and cache the formatter
    this._currencyFormatter = new foundation__WEBPACK_IMPORTED_MODULE_0__.NumberFormatter();
    this._currencyFormatter.init();
    this._currencyFormatter.numberStyle = foundation__WEBPACK_IMPORTED_MODULE_0__.NumberFormatter.Style.currency;
    // Add the stringFromNumber method if it doesn't exist
    // if (!(this._currencyFormatter as any).stringFromNumber) {
    //     (this._currencyFormatter as any).stringFromNumber = function(value: number): string {
    //         return value.toFixed(2); // Simple currency formatting
    //     };
    // }
    return this._currencyFormatter;
};


/***/ }),

/***/ "./sources/DLDB.ts":
/*!*************************!*\
  !*** ./sources/DLDB.ts ***!
  \*************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DLDB: () => (/* binding */ DLDB),
/* harmony export */   RIGHTS_URL: () => (/* binding */ RIGHTS_URL)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _DLDBWebServiceCommand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./DLDBWebServiceCommand */ "./sources/DLDBWebServiceCommand.ts");



var RIGHTS_URL;
(function (RIGHTS_URL) {
    RIGHTS_URL["TERMS"] = "TermsURL";
    RIGHTS_URL["PRIVACY"] = "PrivacyURL";
    RIGHTS_URL["PAYMENT_TERMS"] = "PaymentTermsURL";
})(RIGHTS_URL || (RIGHTS_URL = {}));
;
var DLDB = /** @class */ (function () {
    function DLDB() {
        this.token = null;
        this._currencyFormatter = null;
        this._cart = null;
        // This url will be used in localhost if not overwritten by the environment (USE_LOCAL_API_IN_DEV)
        // This url will be used in production if not overwritten by the environment (API_URL)    
        // private bookingURL: string = "https://test.dual-link.com/booking";
        // private bookingURL: string = "https://v62-staging-hq.dual-link.com/booking";
        // private bookingURL: string = "http://localhost:8102/booking";
        this.bookingURL = "https://staging.dual-link.com/booking";
        this._config = {};
        this._booking_url = null;
        this.request = function (method, path, params, cb, headers) {
            if (headers === void 0) { headers = {}; }
            return this.url_request(method, this._booking_url + path, params, cb, headers);
        };
        this.url_request = function (method, url, params, cb, headers) {
            if (headers === void 0) { headers = {}; }
            var cmd = new _DLDBWebServiceCommand__WEBPACK_IMPORTED_MODULE_1__.DLDBWebServiceCommand(url, null);
            cmd.method = method;
            // TODO: We should put the web channel
            cmd.headers['DL-PLACE-ID'] = this.scheme;
            cmd.headers['DL-APP-ID'] = this.scheme;
            for (var key in headers) {
                cmd.headers[key] = headers[key];
            }
            cmd.params = params;
            cmd.execute(this, cb);
        };
        this._url_params = {};
        this.booking_url = function (path, with_preset) {
            if (with_preset === void 0) { with_preset = true; }
            return "/schema/" + this.scheme + (path || "");
        };
        this.payment_url = function (path, with_preset) {
            if (with_preset === void 0) { with_preset = true; }
            return "/schema/" + this.scheme + (path || "");
        };
        if (DLDB._sharedInstance) {
            throw new Error("DLDB: Instantiation failed: Use shared property instead of new.");
        }
    }
    Object.defineProperty(DLDB, "shared", {
        get: function () {
            if (this._sharedInstance == null) {
                this._sharedInstance = new DLDB();
                // this._sharedInstance.init();
                this._sharedInstance.loadConfig();
            }
            return this._sharedInstance;
        },
        enumerable: false,
        configurable: true
    });
    DLDB.prototype.loadConfig = function () {
        // const url = (window as any).__ENV__.API_URL || this.apiURL;
        // const useLocalApiStr = (window as any).__ENV__.USE_LOCAL_API_IN_DEV || "false";
        // const useLocalApi = useLocalApiStr.toLowerCase() === "true" || useLocalApiStr === "1";
        // console.log("API_URL:", url);
        // console.log("USE_LOCAL_API_IN_DEV str:", useLocalApiStr);
        // console.log("USE_LOCAL_API_IN_DEV:", useLocalApi);
        // const hostname = window.location.hostname;
        // if (hostname === 'localhost' && useLocalApi) {
        //     console.log("Estamos en desarrollo. Puerto ", window.location.port);
        //     this.apiURL = `http://localhost:${window.location.port}/api/`;
        // } else if (hostname.startsWith('webapps.dual-link.com')) {
        //     console.log("Estamos en producción");
        //     this.apiURL = url;
        // }
        var appData = foundation__WEBPACK_IMPORTED_MODULE_0__.Bundle.main.pathForResourceOfType("app", "plist");
        this._config = foundation__WEBPACK_IMPORTED_MODULE_0__.PropertyListSerialization.propertyListWithData(appData, 0, 0, null);
        this.scheme = this._config["OnlineSchemeID"];
        // let langs = this._config["Languages"];
        // this._languages = Object.keys(langs);
        var server_urls = this._config["ServerURLs"];
        if (server_urls != null)
            this._booking_url = server_urls["BookingURL"];
        if (this._booking_url == null)
            this._booking_url = this.bookingURL;
        console.log(server_urls);
        // HACK: Force to load localized strings
        // DOWLLocalizeString( "TITLE" );
    };
    DLDB.prototype.getURL = function (url) { return this._config[url]; };
    Object.defineProperty(DLDB.prototype, "clientCommentOptions", {
        get: function () { return this._config["ClientCommentOptions"]; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DLDB.prototype, "maxPax", {
        get: function () { return this._config["MaxPax"]; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DLDB.prototype, "customCloseDayMessages", {
        get: function () { return this._config["CustomCloseDayMessages"] && this._config["CustomCloseDayMessages"].length > 0 ? this._config["CustomCloseDayMessages"] : null; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DLDB.prototype, "defaultCountryCode", {
        get: function () { return this._config["DefaultCountryCode"]; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DLDB.prototype, "options", {
        set: function (options) {
            this._url_params = options;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DLDB.prototype, "businessAreaID", {
        get: function () {
            return this._url_params["business-area-id"]
                || this._url_params["bid"]
                || this._config["booking-default-online-business-area-id"]
                || "";
        },
        enumerable: false,
        configurable: true
    });
    DLDB.prototype.businessAreaHeader = function () {
        return { "DL-BUSINESS-AREA-ID": this.businessAreaID };
    };
    DLDB.prototype.countries = function (cb) {
        this.request("GET", this.booking_url("/countries", false), {}, cb);
    };
    DLDB.prototype.company = function (cb) {
        this.request("GET", this.booking_url("/business-info", false), {}, cb);
    };
    DLDB.prototype.bookingAvailableDays = function (dateString, cb) {
        this.request("GET", this.booking_url("/available-days/" + dateString), {}, cb, this.businessAreaHeader());
    };
    DLDB.prototype.bookingAvailableRangeForToday = function (dayString, pax, cb) {
        this.request("GET", this.booking_url("/available/" + dayString + "/" + pax), {}, cb, this.businessAreaHeader());
    };
    DLDB.prototype.book = function (opts, cb) {
        this.request("PUT", this.booking_url("/insert", false), opts, cb, this.businessAreaHeader());
    };
    DLDB.prototype.presetProducts = function (parentID, cb) {
        this.request("GET", this.booking_url("/preset-product" + (parentID != null ? "/" + parentID : ""), false), {}, cb, this.businessAreaHeader());
    };
    DLDB.prototype.presetCategories = function (cb) {
        this.request("GET", this.booking_url("/preset-category", false), {}, cb, this.businessAreaHeader());
    };
    DLDB.prototype.checkout = function (url, cb) {
        this.url_request("GET", url, {}, cb, this.businessAreaHeader());
    };
    DLDB._sharedInstance = null;
    return DLDB;
}());



/***/ }),

/***/ "./sources/DLDBWebServiceCommand.ts":
/*!******************************************!*\
  !*** ./sources/DLDBWebServiceCommand.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DLDBWebServiceCommand: () => (/* binding */ DLDBWebServiceCommand)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);




var DLDBWebServiceCommand = /** @class */ (function () {
    function DLDBWebServiceCommand(baseURL, command, binary, headers) {
        this.urlString = null;
        this.method = "GET";
        this.headers = {};
        this.completion = null;
        this.params = null;
        this.formData = null;
        this.blobData = null;
        this.binary = false;
        this.download = false;
        this.urlString = baseURL + (command ? command : "");
        if (binary != null) {
            this.binary = binary;
            if (binary == true)
                this.download = true;
        }
        this.headers = headers || { "Content-Type": "application/json" };
    }
    DLDBWebServiceCommand.prototype.execute = function (target, completion) {
        var request = foundation__WEBPACK_IMPORTED_MODULE_0__.URLRequest.requestWithURL(new URL(this.urlString));
        request.httpMethod = this.method;
        request.binary = this.binary;
        request.download = this.download;
        for (var key in this.headers) {
            var value = this.headers[key];
            request.setHeaderField(key, value);
        }
        var token = foundation__WEBPACK_IMPORTED_MODULE_0__.UserDefaults.standardUserDefaults().valueForKey("LoginToken");
        if (token != null)
            request.setHeaderField("Authorization", "Bearer " + token);
        if (this.params != null)
            request.httpBody = JSON.stringify(this.params);
        else if (this.formData != null)
            request.httpBody = this.formData;
        else if (this.blobData != null)
            request.httpBody = this.blobData;
        foundation__WEBPACK_IMPORTED_MODULE_0__.NotificationCenter.defaultCenter().postNotification("WebServiceCommandBegin", this);
        var urlConnection = new foundation__WEBPACK_IMPORTED_MODULE_0__.URLConnection();
        urlConnection.initWithRequestBlock(request, this, function (statusCode, data, blob) {
            foundation__WEBPACK_IMPORTED_MODULE_0__.NotificationCenter.defaultCenter().postNotification("WebServiceCommandEnd", this);
            if (statusCode < 200 || statusCode >= 300)
                foundation__WEBPACK_IMPORTED_MODULE_0__.NotificationCenter.defaultCenter().postNotification("WebServiceCommandError", null);
            if (completion != null) {
                var json = null;
                if (data != null) {
                    try {
                        json = JSON.parse(data.replace(/(\r\n|\n|\r)/gm, ""));
                    }
                    catch (err) {
                        json = { 'error': 'Server error', 'data': {} };
                    }
                }
                completion.call(target, statusCode, json, blob);
            }
        });
    };
    return DLDBWebServiceCommand;
}());



/***/ }),

/***/ "foundation":
/*!*****************************!*\
  !*** external "foundation" ***!
  \*****************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_foundation__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!***************************!*\
  !*** ./sources/_index.ts ***!
  \***************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Booking: () => (/* reexport safe */ _DLDB_Bookings__WEBPACK_IMPORTED_MODULE_1__.Booking),
/* harmony export */   Cart: () => (/* reexport safe */ _DLDB_Cart__WEBPACK_IMPORTED_MODULE_4__.Cart),
/* harmony export */   CartLine: () => (/* reexport safe */ _DLDB_Cart__WEBPACK_IMPORTED_MODULE_4__.CartLine),
/* harmony export */   DLDB: () => (/* reexport safe */ _DLDB__WEBPACK_IMPORTED_MODULE_0__.DLDB),
/* harmony export */   DLDBWebServiceCommand: () => (/* reexport safe */ _DLDBWebServiceCommand__WEBPACK_IMPORTED_MODULE_2__.DLDBWebServiceCommand),
/* harmony export */   RIGHTS_URL: () => (/* reexport safe */ _DLDB__WEBPACK_IMPORTED_MODULE_0__.RIGHTS_URL),
/* harmony export */   isValidEmail: () => (/* reexport safe */ _DLDB_Bookings__WEBPACK_IMPORTED_MODULE_1__.isValidEmail),
/* harmony export */   isValidPhone: () => (/* reexport safe */ _DLDB_Bookings__WEBPACK_IMPORTED_MODULE_1__.isValidPhone),
/* harmony export */   isValidPostalCode: () => (/* reexport safe */ _DLDB_Bookings__WEBPACK_IMPORTED_MODULE_1__.isValidPostalCode)
/* harmony export */ });
/* harmony import */ var _DLDB__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DLDB */ "./sources/DLDB.ts");
/* harmony import */ var _DLDB_Bookings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./DLDB+Bookings */ "./sources/DLDB+Bookings.ts");
/* harmony import */ var _DLDBWebServiceCommand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./DLDBWebServiceCommand */ "./sources/DLDBWebServiceCommand.ts");
/* harmony import */ var _DLDB_Formatters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./DLDB+Formatters */ "./sources/DLDB+Formatters.ts");
/* harmony import */ var _DLDB_Cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./DLDB+Cart */ "./sources/DLDB+Cart.ts");






/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=dldb.js.map